import {createContext} from 'react';

export type ConfirmationContextType = {
    changedChunks: string[],
    isChunkChanged: (chunkName: string) => boolean,
    addChangedChunk: (name: string) => void,
    removeChangedChunk: (name: string) => void,
    onShowModal: (onConfirm: () => void) => void,
};

export const ConfirmationContext = createContext<ConfirmationContextType>({
    changedChunks: [],
    isChunkChanged: () => false,
    addChangedChunk: () => undefined,
    removeChangedChunk: () => undefined,
    onShowModal: () => undefined,
});
